<template>
  <section class="page-search-company">
    <div class="page-search-company__content">
      <div class="page-search-company__searchbar">
        <gf-search-bar
          class="searchbar"
          :selected-search="$route.query?.q"
          @submit="onSearchSubmit"
        />
        <div class="page-search-company__sort">
          <gf-custom-sort
            :option-types="companySortingOptionTypes"
            :selected-sort="selectedSort"
            @submit="onSortSubmit"
          />
          <gf-button
            class="mobile-filters"
            variant="muted"
            icon="gf-icon-sliders"
            @click="openMobileFilters"
          ></gf-button>
        </div>
      </div>
      <div class="page-search-company__list">
        <companies-list
          view-type="list"
          :companies-list="companiesList"
          :page="page"
          :empty-content="
            $route.query.q?.length > 0 ? $t('search.notFound') : $t('search.noParams')
          "
        />
      </div>
    </div>
    <div class="page-search-company__navigation">
      <div class="page-search-company__menu"><gf-search-navigation /></div>
      <!-- v-if="(applicationVersion === 'cloudweb' && companiesList?.length > 0) || hasFilters" -->
      <gf-search-company-filters
        v-if="companiesList?.length > 0 || hasFilters"
        :is-opened="isFiltersOpened"
        @close="isFiltersOpened = false"
      ></gf-search-company-filters>
    </div>
  </section>
</template>

<script>
import SearchService from '@shared/modules/search/search.service';
import { companySortingOptionTypes } from '@shared/modules/search/search.constants';
import GfSearchBar from '@shared/shared-components/shared/filter/GfSearchBar';
import CompaniesList from '@shared/modules/company/components/CompaniesList';
import GfSearchNavigation from '@shared/modules/search/components/navigation/GfSearchNavigation';
// eslint-disable-next-line max-len
import SearchMessages from '@shared/modules/search/search.messages';
import GfCustomSort from '@/shared-modules/shared-components/shared/filter/GfCustomSort';
import GfButton from '@/shared-modules/shared-components/shared/components/GfButton';
import GfSearchCompanyFilters from '@shared/modules/search/components/filters/company/GfSearchCompanyFilters';

export default {
  name: 'PageSearchCompany',
  components: {
    GfSearchBar,
    GfCustomSort,
    CompaniesList,
    GfSearchNavigation,
    GfButton,
    GfSearchCompanyFilters
  },
  data() {
    return {
      companySortingOptionTypes,
      selectedSort: {},
      page: null,
      companiesList: null,
      isFiltersOpened: false
    };
  },
  computed: {
    hasFilters() {
      return this.$route.query?.verifiedOnly;
    },
    applicationVersion() {
      return this.$store.getters.getApplicationVersion;
    }
  },
  watch: {
    '$route.query': function () {
      this.searchCompany();
    }
  },
  mounted() {
    this.fillSelectedSort();
    this.searchCompany();
  },
  methods: {
    searchCompany() {
      if (this.$route.query.q?.length > 0) {
        const hadCompanies = this.companiesList !== null;
        this.companiesList = null;
        this.page = null;
        SearchService.searchCompany(this.$route.query, !this.hasFilters || !hadCompanies)
          .then((res) => {
            this.companiesList = res?.companies?.content || [];
            this.page = res?.companies?.page;
          })
          .catch(() => {
            this.companiesList = [];
          });
      } else {
        this.companiesList = [];
      }
    },
    resetSavedFiltersAndCounters() {
      this.$store.dispatch('updateSearchCounters', {});
    },
    onSearchSubmit(data) {
      this.resetSavedFiltersAndCounters();
      this.$router.push({
        query: { ...this.$route?.query, q: data, page: 0 }
      });
    },
    fillSelectedSort() {
      if (this.$route.query?.sort) {
        this.selectedSort = {
          key: this.$route.query?.sort,
          value: this.$route.query?.direction
        };
      }
    },
    onSortSubmit(data) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: 0,
          sort: data.key,
          direction: data.value
        }
      });
    },
    openMobileFilters() {
      this.isFiltersOpened = true;
    }
  },
  i18n: {
    messages: SearchMessages
  }
};
</script>

<style lang="scss">
$this: '.page-search-company';

#{$this} {
  display: flex;
  flex-direction: column-reverse;
  gap: 14px;

  @include theme.md {
    flex-direction: row;
    gap: 28px;
  }

  #{$this}__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 14px;

    #{$this}__searchbar {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      gap: 14px;

      @include theme.md {
        flex-direction: row;
      }

      & .searchbar {
        width: 100%;
      }

      #{$this}__sort {
        width: 100%;
        display: flex;
        justify-content: space-between;
        gap: 14px;

        @include theme.md {
          width: auto;
        }

        & > .mobile-filters {
          display: flex;

          @include theme.md {
            display: none;
          }
        }
      }
    }
  }

  #{$this}__navigation {
    width: 100%;
    display: flex;
    flex-direction: column;

    @include theme.md {
      width: auto;
      min-width: 300px;
    }
  }

  & button:focus {
    box-shadow: none;
  }
}
</style>
